import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Icon from "./Icon.jsx";
import AppUtils from "@src/utils/appUtils";

const Modal = ({
  open,
  handleClose,
  children,
  size = "default",
  hideCloseButton = false,
  primary = false,
}) => {
  const sizeClasses = {
    default: "w-full max-w-md xl:max-w-lg overflow-auto",
    fullwidth: "w-full overflow-auto",
    onboarding: "h-auto w-9/10 sm:w-[540px] sm:min-h-[540px]",
    email: "w-full max-w-[606px] h-full",
    fullscreen: "w-full h-full max-w-none overflow-auto",
  };
  const sizeClass = sizeClasses[size];

  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Clean up when unmounted (important for ESC key or route change)
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className={`z-999 fixed inset-0 flex justify-center backdrop-blur-sm px-4 py-8
        ${size === "onboarding" ? "items-start overflow-y-auto [@media(min-height:644px)]:items-center" : "items-center"}
        ${primary ? "bg-primary-600/50" : "bg-black/50"}`}
      onClick={
        hideCloseButton !== true
          ? handleClose
          : () => console.log("outside click disabled")
      }
    >
      <div
        className={`relative z-999 bg-white rounded-2xl shadow-lg ${sizeClass} content-center`}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxHeight: size === "onboarding" ? undefined : "calc(100% - 42px)",
        }}
      >
        <div
          className={`flex flex-col h-full items-center overflow-y-auto overflow-x-hidden custom-scroll`}
        >
          {children}
        </div>
        {hideCloseButton !== true && (
          <button
            onClick={handleClose}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 cursor-pointer transition-all hover:-translate-y-px active:translate-y-px"
          >
            <Icon
              name="close"
              centered={false}
              size="xl"
              backgroundColor="transparent"
            />
          </button>
        )}
      </div>
    </div>,
    document.getElementById("modal-root"),
  );
};

export const modalControls = {
  open: {
    propType: PropTypes.bool,
    description: "Controls modal visibility",
    controlType: "boolean",
    defaultValue: false,
  },
  handleClose: {
    propType: PropTypes.func.isRequired,
    description: "Close handler function",
    disable: true,
  },
  size: {
    propType: PropTypes.oneOf(["default", "onboarding", "email", "fullscreen"]),
    description: "modal pop-up frame size",
    controlType: "select",
    options: ["default", "onboarding", "email", "fullscreen"],
    defaultValue: "default",
  },
  hideClose: {
    propType: PropTypes.bool,
    description: "if close button should be hidden",
  },
  children: {
    propType: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Modal content",
    disable: true,
  },
};

Modal.propTypes = AppUtils.getPropTypeFromControls(modalControls);

export default Modal;
